export const enum TruckingCompanyInsuredType {
  Commercial = 0,
  Personal = 1,
  LifeHealthGroup = 2,
  LifeHealthIndividual = 3,
  Medicare = 4
}